import { CChainInputOutput, ExportImportTransaction } from "../models/Transaction";

export function calculateAmount(tx: ExportImportTransaction): number {
  let amount = 0;
  if (tx.type === "import") {
    amount = tx.importedoutput_set?.reduce((sum: number, item: CChainInputOutput) => sum + item.value, 0 ) ?? 0;
  } else if (tx.type === "export") {
    amount = tx.exportedoutput_set?.reduce((sum: number, item: CChainInputOutput) => sum + item.value, 0 ) ?? 0;
  }
  return amount;
}